export const help = (i18n) => ({
  /* i18n-block-start except: ["en"] */
  label: () => i18n.gettext('Necesito ayuda para iniciar sesión'),
  title: () => i18n.gettext('Necesito ayuda para iniciar sesión'),
  labelV2: () => i18n.gettext('Necesito ayuda'),
  /* i18n-block-end */
});
